// Generated from management-api/src/time_series/domain/data/time_series_templates.py
// Do not edit manually - run tools/compile_templates_to_typescript.py to regenerate

export interface ComplexDataFieldDefinition {
  name: string;
  factor?: number;
  unit_field?: string;
  unit_conversions?: { [key: string]: number };
}

export interface FieldDefinition {
  name: string;
  unit?: string;
  field:
    | string
    | ComplexDataFieldDefinition
    | { [key: string]: Array<ComplexDataFieldDefinition> }
    | Array<string | ComplexDataFieldDefinition>;
  aggregations: Array<string>;
  category: string;
  cumulative?: boolean;
}

export interface AssetTypeDefinition {
  data_fields: Array<FieldDefinition>;
  aggregations: Array<any>;
  compound_aggregations: Array<FieldDefinition>;
}

export type AssetDefinitionMap = { [key: string]: AssetTypeDefinition };

export const TIME_SERIES_TEMPLATES: AssetDefinitionMap = {
  heat_meter: {
    data_fields: [
      {
        name: "Energy (Heating)",
        unit: "Wh",
        field: {
          elvaco_mbus: [
            {
              name: "energy,Wh,inst-value,0,0,0",
            },
            {
              name: "energy acc-only-if-pos-contr,Wh,inst-value,0,0,0",
            },
            {
              name: "energy,kWh,inst-value,0,0,0",
              factor: 1000,
            },
            {
              name: "energy,MWh,inst-value,0,0,0",
              factor: 1000000,
            },
          ],
          guru_systems: [
            {
              name: "4",
            },
          ],
          guru_systems_csv: [
            {
              name: "Meter Reading",
              factor: 1000,
            },
          ],
          p2lpc: [
            {
              name: "0.1.24.2.2",
              factor: 1000000,
            },
          ],
          evinox_csv: [
            {
              name: "Reading",
              factor: 1000,
            },
          ],
          switch2_g6_csv: [
            {
              name: "EnergyKiloWattHour",
              factor: 1000,
            },
          ],
          switch2_cmi6110: [
            {
              name: "E",
              unit_field: "U",
              unit_conversions: {
                Wh: 1,
                kWh: 1000,
                MWh: 1000000,
              },
            },
          ],
          email_receiver: [
            {
              name: "value",
              unit_field: "unit",
              unit_conversions: {
                Wh: 1,
                kWh: 1000,
                MWh: 1000000,
              },
            },
          ],
          kamstrup_ready_csv_v1: [
            {
              name: "Energy 1 Heat energy",
              unit_field: "Unit",
              unit_conversions: {
                Wh: 1,
                kWh: 1000,
                MWh: 1000000,
              },
            },
          ],
        },
        aggregations: ["count", "last", "difference"],
        category: "basic",
        cumulative: true,
      },
      {
        name: "Flow",
        unit: "m3/h",
        field: {
          elvaco_mbus: [
            {
              name: "volume-flow,m3/h,inst-value,0,0,0",
            },
            {
              name: "volume,m3/min,inst-value,0,0,0",
              factor: 60,
            },
          ],
          guru_systems: [
            {
              name: "6",
            },
          ],
          guru_systems_csv: [
            {
              name: "Instantaneous Flow",
            },
          ],
          evinox_csv: [
            {
              name: "Flow",
              factor: 0.001,
            },
          ],
          switch2_g6_csv: [
            {
              name: "FlowLitrePerSecond",
              factor: 0.277777777777777,
            },
          ],
          switch2_cmi6110: [
            {
              name: "F",
              unit_field: "FU",
              unit_conversions: {
                "m3/h": 1,
                "l/h": 0.001,
                "l/min": 0.06,
              },
            },
          ],
          kamstrup_ready_csv_v1: [
            {
              name: "Flow 1",
              unit_field: "Unit",
              unit_conversions: {
                "m3/h": 1,
                "l/h": 0.001,
                "l/min": 0.06,
              },
            },
          ],
        },
        aggregations: ["count", "min", "max", "mean", "time_weighted_average"],
        category: "technical",
      },
      {
        name: "Flow Temperature",
        unit: "°C",
        field: {
          elvaco_mbus: [
            {
              name: "flow-temp,°C,inst-value,0,0,0",
            },
            {
              name: "flow-temperature,˚C,inst-value,0,0,0",
            },
          ],
          guru_systems: [
            {
              name: "1",
            },
          ],
          guru_systems_csv: [
            {
              name: "Flow Temp",
            },
          ],
          evinox_csv: [
            {
              name: "FlowTemp",
            },
          ],
          switch2_g6_csv: [
            {
              name: "FlowCentigrade",
            },
          ],
          switch2_cmi6110: [
            {
              name: "FT",
              unit_field: "TU",
              unit_conversions: {
                C: 1,
                "°C": 1,
              },
            },
          ],
          kamstrup_ready_csv_v1: [
            {
              name: "Temperature 1",
              unit_field: "Unit",
              unit_conversions: {
                C: 1,
                "°C": 1,
              },
            },
          ],
        },
        aggregations: [
          "count",
          "min",
          "max",
          "mean",
          "time_weighted_average",
          "volume_weighted_average",
          "volume_weighted_average_(domestic_hot_water)",
          "volume_weighted_average_(standby)",
          "volume_weighted_average_(passive_standby)",
          "volume_weighted_average_(error)",
          "volume_weighted_average_(space_heating)",
        ],
        category: "technical",
      },
      {
        name: "Return Temperature",
        unit: "°C",
        field: {
          elvaco_mbus: [
            {
              name: "return-temp,°C,inst-value,0,0,0",
            },
            {
              name: "return-temperature,˚C,inst-value,0,0,0",
            },
          ],
          guru_systems: [
            {
              name: "2",
            },
          ],
          guru_systems_csv: [
            {
              name: "Return Temp",
            },
          ],
          evinox_csv: [
            {
              name: "RetTemp",
            },
          ],
          switch2_g6_csv: [
            {
              name: "ReturnCentigrade",
            },
          ],
          switch2_cmi6110: [
            {
              name: "RT",
              unit_field: "RU",
              unit_conversions: {
                C: 1,
                "°C": 1,
              },
            },
          ],
          kamstrup_ready_csv_v1: [
            {
              name: "Temperature 2",
              unit_field: "Unit",
              unit_conversions: {
                C: 1,
                "°C": 1,
              },
            },
          ],
        },
        aggregations: [
          "count",
          "min",
          "max",
          "mean",
          "time_weighted_average",
          "volume_weighted_average",
          "volume_weighted_average_(domestic_hot_water)",
          "volume_weighted_average_(standby)",
          "volume_weighted_average_(passive_standby)",
          "volume_weighted_average_(error)",
          "volume_weighted_average_(space_heating)",
        ],
        category: "technical",
      },
      {
        name: "Power",
        unit: "W",
        field: {
          elvaco_mbus: [
            {
              name: "power,W,inst-value,0,0,0",
            },
          ],
          guru_systems: [
            {
              name: "7",
            },
          ],
          guru_systems_csv: [
            {
              name: "Instantaneous Power",
              factor: 1000,
            },
          ],
          evinox_csv: [
            {
              name: "InstPower",
              factor: 1000,
            },
          ],
          switch2_g6_csv: [
            {
              name: "PowerKiloWatt",
              factor: 1000,
            },
          ],
          switch2_cmi6110: [
            {
              name: "P",
              unit_field: "PU",
              unit_conversions: {
                W: 1,
                kW: 1000,
                MW: 1000000,
              },
            },
          ],
          kamstrup_ready_csv_v1: [
            {
              name: "Power 1",
              unit_field: "Unit",
              unit_conversions: {
                W: 1,
                kW: 1000,
                MW: 1000000,
              },
            },
          ],
        },
        aggregations: ["count", "min", "max", "mean", "time_weighted_average"],
        category: "technical",
      },
      {
        name: "Volume",
        unit: "m3",
        field: {
          elvaco_mbus: [
            {
              name: "volume,m3,inst-value,0,0,0",
            },
          ],
          guru_systems: [
            {
              name: "5",
            },
          ],
          guru_systems_csv: [
            {
              name: "Total Flow",
            },
          ],
          evinox_csv: [
            {
              name: "FlowTotal",
            },
          ],
          switch2_g6_csv: [
            {
              name: "VolumeCubicMetre",
            },
          ],
          switch2_cmi6110: [
            {
              name: "V",
              unit_field: "VU",
              unit_conversions: {
                m3: 1,
                l: 0.001,
                dm3: 0.001,
              },
            },
          ],
          kamstrup_ready_csv_v1: [
            {
              name: "Volume 1",
              unit_field: "Unit",
              unit_conversions: {
                m3: 1,
                l: 0.001,
                dm3: 0.001,
              },
            },
          ],
        },
        aggregations: ["count", "last", "difference"],
        category: "technical",
        cumulative: true,
      },
    ],
    compound_aggregations: [
      {
        name: "Synthetic Volume",
        unit: "m3",
        field: "sythetic_volume",
        aggregations: [
          "sum_estimated_forward_volume",
          "sum_estimated_reverse_volume",
          "sum_estimated_volume",
        ],
        category: "sythetic",
      },
      {
        name: "Synthetic Energy",
        unit: "Wh",
        field: "sythetic_energy",
        aggregations: [
          "sum_estimated_forward_heating_energy",
          "sum_estimated_forward_cooling_energy",
          "sum_estimated_forward_net_energy",
          "sum_estimated_reverse_heating_energy",
          "sum_estimated_reverse_cooling_energy",
          "sum_estimated_reverse_net_energy",
          "sum_estimated_net_energy",
        ],
        category: "sythetic",
      },
      {
        name: "Synthetic Run Time",
        unit: "minutes",
        field: "run_time",
        aggregations: [
          "sum_(domestic_hot_water)",
          "sum_(space_heating)",
          "sum_(standby)",
          "sum_(passive_standby)",
          "sum_(error)",
          "sum_(unknown)",
        ],
        category: "sythetic",
      },
    ],
    aggregations: [
      {
        data_fields: ["Energy (Heating)", "Volume"],
        aggregations: ["count", "last"],
      },
      {
        data_fields: ["Flow", "Power"],
        aggregations: ["count", "min", "max", "mean", "time_weighted_average"],
      },
      {
        data_fields: ["Flow Temperature", "Return Temperature"],
        aggregations: ["count", "min", "max", "mean", "time_weighted_average"],
      },
    ],
  },
  heating_and_cooling_meter: {
    data_fields: [
      {
        name: "Energy (Heating)",
        unit: "Wh",
        field: {
          elvaco_mbus: [
            {
              name: "energy acc-only-if-pos-contr,Wh,inst-value,0,0,0",
            },
            {
              name: "energy,Wh,inst-value,0,0,0",
            },
            {
              name: "energy,kWh,inst-value,0,0,0",
              factor: 1000,
            },
            {
              name: "energy,MWh,inst-value,0,0,0",
              factor: 1000000,
            },
          ],
        },
        aggregations: ["count", "last", "difference"],
        category: "basic",
        cumulative: true,
      },
      {
        name: "Energy (Cooling)",
        unit: "Wh",
        field: {
          elvaco_mbus: [
            {
              name: "energy acc-of-abs-value-only-if-neg-contr,Wh,inst-value,0,0,0",
            },
            {
              name: "energy acc-only-if-neg-contr,Wh,inst-value,0,0,0",
            },
            {
              name: "energy-backward-flow-only-accumulation,Wh,inst-value,0,0,0",
            },
            {
              name: "energy,Wh,inst-value,1,0,0",
            },
            {
              name: "energy,kWh,inst-value,0,0,0",
              factor: 1000,
            },
            {
              name: "energy,MWh,inst-value,0,0,0",
              factor: 1000000,
            },
          ],
        },
        aggregations: ["count", "last", "difference"],
        category: "basic",
        cumulative: true,
      },
      {
        name: "Flow",
        unit: "m3/h",
        field: {
          elvaco_mbus: [
            {
              name: "volume-flow,m3/h,inst-value,0,0,0",
            },
            {
              name: "volume,m3/min,inst-value,0,0,0",
              factor: 60,
            },
          ],
        },
        aggregations: ["count", "min", "max", "mean", "time_weighted_average"],
        category: "technical",
      },
      {
        name: "Flow Temperature",
        unit: "°C",
        field: {
          elvaco_mbus: [
            {
              name: "flow-temp,°C,inst-value,0,0,0",
            },
            {
              name: "flow-temperature,˚C,inst-value,0,0,0",
            },
          ],
        },
        aggregations: [
          "count",
          "min",
          "max",
          "mean",
          "time_weighted_average",
          "volume_weighted_average",
          "volume_weighted_average_(domestic_hot_water)",
          "volume_weighted_average_(standby)",
          "volume_weighted_average_(passive_standby)",
          "volume_weighted_average_(error)",
          "volume_weighted_average_(space_heating)",
        ],
        category: "technical",
      },
      {
        name: "Return Temperature",
        unit: "°C",
        field: {
          elvaco_mbus: [
            {
              name: "return-temp,°C,inst-value,0,0,0",
            },
            {
              name: "return-temperature,˚C,inst-value,0,0,0",
            },
          ],
        },
        aggregations: [
          "count",
          "min",
          "max",
          "mean",
          "time_weighted_average",
          "volume_weighted_average",
          "volume_weighted_average_(domestic_hot_water)",
          "volume_weighted_average_(standby)",
          "volume_weighted_average_(passive_standby)",
          "volume_weighted_average_(error)",
          "volume_weighted_average_(space_heating)",
        ],
        category: "technical",
      },
      {
        name: "Power",
        unit: "W",
        field: {
          elvaco_mbus: [
            {
              name: "power,W,inst-value,0,0,0",
            },
          ],
        },
        aggregations: ["count", "min", "max", "mean", "time_weighted_average"],
        category: "technical",
      },
      {
        name: "Volume",
        unit: "m3",
        field: {
          elvaco_mbus: [
            {
              name: "volume,m3,inst-value,0,0,0",
            },
          ],
        },
        aggregations: ["count", "last", "difference"],
        category: "technical",
        cumulative: true,
      },
    ],
    compound_aggregations: [
      {
        name: "Synthetic Volume",
        unit: "m3",
        field: "sythetic_volume",
        aggregations: [
          "sum_estimated_forward_volume",
          "sum_estimated_reverse_volume",
          "sum_estimated_volume",
        ],
        category: "sythetic",
      },
      {
        name: "Synthetic Energy",
        unit: "Wh",
        field: "sythetic_energy",
        aggregations: [
          "sum_estimated_forward_heating_energy",
          "sum_estimated_forward_cooling_energy",
          "sum_estimated_forward_net_energy",
          "sum_estimated_reverse_heating_energy",
          "sum_estimated_reverse_cooling_energy",
          "sum_estimated_reverse_net_energy",
          "sum_estimated_net_energy",
        ],
        category: "sythetic",
      },
      {
        name: "Synthetic Run Time",
        unit: "minutes",
        field: "run_time",
        aggregations: [
          "sum_(domestic_hot_water)",
          "sum_(space_heating)",
          "sum_(standby)",
          "sum_(passive_standby)",
          "sum_(error)",
          "sum_(unknown)",
        ],
        category: "sythetic",
      },
    ],
    aggregations: [
      {
        data_fields: ["Energy (Cooling)", "Energy (Heating)", "Volume"],
        aggregations: ["count", "last"],
      },
      {
        data_fields: ["Flow", "Power"],
        aggregations: ["count", "min", "max", "mean", "time_weighted_average"],
      },
      {
        data_fields: ["Flow Temperature", "Return Temperature"],
        aggregations: ["count", "min", "max", "mean", "time_weighted_average"],
      },
    ],
  },
  cooling_meter: {
    data_fields: [
      {
        name: "Energy (Cooling)",
        unit: "Wh",
        field: {
          elvaco_mbus: [
            {
              name: "energy acc-of-abs-value-only-if-neg-contr,Wh,inst-value,0,0,0",
            },
            {
              name: "energy acc-only-if-neg-contr,Wh,inst-value,0,0,0",
            },
            {
              name: "energy,Wh,inst-value,0,0,0",
            },
            {
              name: "energy,kWh,inst-value,0,0,0",
              factor: 1000,
            },
            {
              name: "energy,MWh,inst-value,0,0,0",
              factor: 1000000,
            },
          ],
          guru_systems: [
            {
              name: "4",
            },
          ],
          guru_systems_csv: [
            {
              name: "Meter Reading",
              factor: 1000,
            },
          ],
          evinox_csv: [
            {
              name: "Reading",
              factor: 1000,
            },
          ],
        },
        aggregations: ["count", "last", "difference"],
        category: "basic",
        cumulative: true,
      },
      {
        name: "Flow",
        unit: "m3/h",
        field: {
          elvaco_mbus: [
            {
              name: "volume-flow,m3/h,inst-value,0,0,0",
            },
          ],
          guru_systems: [
            {
              name: "6",
            },
          ],
          guru_systems_csv: [
            {
              name: "Instantaneous Flow",
            },
          ],
          evinox_csv: [
            {
              name: "Flow",
              factor: 0.001,
            },
          ],
        },
        aggregations: ["count", "min", "max", "mean", "time_weighted_average"],
        category: "technical",
      },
      {
        name: "Flow Temperature",
        unit: "°C",
        field: {
          elvaco_mbus: [
            {
              name: "flow-temp,°C,inst-value,0,0,0",
            },
            {
              name: "flow-temperature,˚C,inst-value,0,0,0",
            },
          ],
          guru_systems: [
            {
              name: "1",
            },
          ],
          guru_systems_csv: [
            {
              name: "Flow Temp",
            },
          ],
          evinox_csv: [
            {
              name: "FlowTemp",
            },
          ],
        },
        aggregations: [
          "count",
          "min",
          "max",
          "mean",
          "time_weighted_average",
          "volume_weighted_average",
          "volume_weighted_average_(standby)",
          "volume_weighted_average_(error)",
          "volume_weighted_average_(passive_standby)",
          "volume_weighted_average_(space_cooling)",
        ],
        category: "technical",
      },
      {
        name: "Return Temperature",
        unit: "°C",
        field: {
          elvaco_mbus: [
            {
              name: "return-temp,°C,inst-value,0,0,0",
            },
            {
              name: "return-temperature,˚C,inst-value,0,0,0",
            },
          ],
          guru_systems: [
            {
              name: "2",
            },
          ],
          guru_systems_csv: [
            {
              name: "Return Temp",
            },
          ],
          evinox_csv: [
            {
              name: "RetTemp",
            },
          ],
        },
        aggregations: [
          "count",
          "min",
          "max",
          "mean",
          "time_weighted_average",
          "volume_weighted_average",
          "volume_weighted_average_(standby)",
          "volume_weighted_average_(error)",
          "volume_weighted_average_(passive_standby)",
          "volume_weighted_average_(space_cooling)",
        ],
        category: "technical",
      },
      {
        name: "Power",
        unit: "W",
        field: {
          elvaco_mbus: [
            {
              name: "power,W,inst-value,0,0,0",
            },
          ],
          guru_systems: [
            {
              name: "7",
            },
          ],
          guru_systems_csv: [
            {
              name: "Instantaneous Power",
              factor: 1000,
            },
          ],
          evinox_csv: [
            {
              name: "InstPower",
              factor: 1000,
            },
          ],
        },
        aggregations: ["count", "min", "max", "mean", "time_weighted_average"],
        category: "technical",
      },
      {
        name: "Volume",
        unit: "m3",
        field: {
          elvaco_mbus: [
            {
              name: "volume,m3,inst-value,0,0,0",
            },
          ],
          guru_systems: [
            {
              name: "5",
            },
          ],
          guru_systems_csv: [
            {
              name: "Total Flow",
            },
          ],
          evinox_csv: [
            {
              name: "FlowTotal",
            },
          ],
        },
        aggregations: ["count", "last", "difference"],
        category: "technical",
        cumulative: true,
      },
    ],
    compound_aggregations: [
      {
        name: "Synthetic Volume",
        unit: "m3",
        field: "sythetic_volume",
        aggregations: [
          "sum_estimated_forward_volume",
          "sum_estimated_reverse_volume",
          "sum_estimated_volume",
        ],
        category: "sythetic",
      },
      {
        name: "Synthetic Energy",
        unit: "Wh",
        field: "sythetic_energy",
        aggregations: [
          "sum_estimated_forward_heating_energy",
          "sum_estimated_forward_cooling_energy",
          "sum_estimated_forward_net_energy",
          "sum_estimated_reverse_heating_energy",
          "sum_estimated_reverse_cooling_energy",
          "sum_estimated_reverse_net_energy",
          "sum_estimated_net_energy",
        ],
        category: "sythetic",
      },
      {
        name: "Synthetic Run Time",
        unit: "minutes",
        field: "run_time",
        aggregations: [
          "sum_(space_cooling)",
          "sum_(standby)",
          "sum_(passive_standby)",
          "sum_(error)",
          "sum_(unknown)",
        ],
        category: "sythetic",
      },
    ],
    aggregations: [
      {
        data_fields: ["Energy (Cooling)", "Volume"],
        aggregations: ["count", "last"],
      },
      {
        data_fields: ["Flow", "Power"],
        aggregations: ["count", "min", "max", "mean", "time_weighted_average"],
      },
      {
        data_fields: ["Flow Temperature", "Return Temperature"],
        aggregations: ["count", "min", "max", "mean", "time_weighted_average"],
      },
    ],
  },
  electricity_meter: {
    data_fields: [
      {
        name: "Energy (Electrical Active Import)",
        unit: "Wh",
        field: {
          elvaco_mbus: [
            {
              name: "energy acc-only-if-pos-contr,Wh,inst-value,0,0,0",
            },
            {
              name: "energy,Wh,inst-value,0,0,0",
            },
            {
              name: "energy no-error,Wh,inst-value,0,0,0",
            },
            {
              name: "energy acc-only-if-pos-contr,10Wh,inst-value,0,0,0",
              factor: 10,
            },
          ],
          guru_systems: [
            {
              name: "4",
            },
          ],
          guru_systems_csv: [
            {
              name: "Meter Reading",
              factor: 1000,
            },
          ],
          p2lpc: [
            {
              name: "1.8.0",
              factor: 1000,
            },
          ],
          evinox_csv: [
            {
              name: "Reading",
              factor: 1000,
            },
          ],
          email_receiver: [
            {
              name: "value",
              unit_field: "unit",
              unit_conversions: {
                Wh: 1,
                kWh: 1000,
                MWh: 1000000,
              },
            },
          ],
        },
        aggregations: ["count", "last", "difference"],
        category: "basic",
        cumulative: true,
      },
      {
        name: "Energy (Electrical Active Export)",
        unit: "Wh",
        field: {
          elvaco_mbus: [
            {
              name: "energy acc-of-abs-value-only-if-neg-contr,Wh,inst-value,0,0,0",
            },
            {
              name: "energy acc-of-abs-value-only-if-neg-contr,10Wh,inst-value,0,0,0",
              factor: 10,
            },
          ],
        },
        aggregations: ["count", "last", "difference"],
        category: "technical",
        cumulative: true,
      },
      {
        name: "Energy (Electrical Reactive Import)",
        unit: "kVARh",
        field: {
          elvaco_mbus: [
            {
              name: "reactive-energy acc-only-if-pos-contr,kVARh,inst-value,0,0,0",
            },
            {
              name: "reactive-energy acc-only-if-pos-contr,10kVARh,inst-value,0,0,0",
              factor: 10,
            },
          ],
        },
        aggregations: ["count", "last", "difference"],
        category: "technical",
        cumulative: true,
      },
      {
        name: "Energy (Electrical Reactive Export)",
        unit: "kVARh",
        field: {
          elvaco_mbus: [
            {
              name: "reactive-energy acc-of-abs-value-only-if-neg-contr,kVARh,inst-value,0,0,0",
            },
            {
              name: "reactive-energy acc-of-abs-value-only-if-neg-contr,10kVARh,inst-value,0,0,0",
              factor: 10,
            },
          ],
        },
        aggregations: ["count", "last", "difference"],
        category: "technical",
        cumulative: true,
      },
      {
        name: "Power",
        unit: "W",
        field: {
          elvaco_mbus: [
            {
              name: "power,W,inst-value,0,0,0",
            },
            {
              name: "power,W,inst-value,0,1,0",
            },
            {
              name: "power no-error,W,inst-value,0,0,0",
            },
          ],
        },
        aggregations: ["count", "min", "max", "mean", "time_weighted_average"],
        category: "technical",
      },
      {
        name: "Reactive Power",
        unit: "kVAR",
        field: {
          elvaco_mbus: [
            {
              name: "reactive-energy  ,kVARh/h,inst-value,0,1,0",
            },
          ],
        },
        aggregations: ["count", "min", "max", "mean", "time_weighted_average"],
        category: "technical",
      },
      {
        name: "Current",
        unit: "A",
        field: {
          elvaco_mbus: [
            {
              name: "current,A,inst-value,0,0,0",
            },
            {
              name: "current,A,inst-value,0,1,0",
            },
            {
              name: "current manufacturer-specific-81-00,A,inst-value,0,0,0",
            },
          ],
        },
        aggregations: ["count", "min", "max", "mean", "time_weighted_average"],
        category: "technical",
      },
      {
        name: "Frequency",
        unit: "Hz",
        field: {
          elvaco_mbus: [
            {
              name: "frequency,Hz,inst-value,0,0,0",
            },
            {
              name: "Hz ,,inst-value,0,0,0",
            },
          ],
        },
        aggregations: ["count", "min", "max", "mean", "time_weighted_average"],
        category: "technical",
      },
      {
        name: "Power Factor",
        unit: "",
        field: {
          elvaco_mbus: [
            {
              name: "CosPhi ,,inst-value,0,0,0",
            },
          ],
        },
        aggregations: ["count", "min", "max", "mean", "time_weighted_average"],
        category: "technical",
      },
    ],
    aggregations: [
      {
        data_fields: [
          "Energy (Electrical Active Import)",
          "Energy (Electrical Active Export)",
          "Energy (Electrical Reactive Import)",
          "Energy (Electrical Reactive Export)",
        ],
        aggregations: ["count", "last"],
      },
      {
        data_fields: ["Frequency", "Power", "Reactive Power", "Power Factor", "Current"],
        aggregations: ["count", "min", "max", "mean", "time_weighted_average"],
      },
    ],
    compound_aggregations: [],
  },
  water_meter: {
    data_fields: [
      {
        name: "Volume",
        unit: "m3",
        field: {
          elvaco_mbus: [
            {
              name: "volume,m3,inst-value,0,0,0",
            },
          ],
          evinox_csv: [
            {
              name: "Reading",
              factor: 0.001,
            },
          ],
          email_receiver: [
            {
              name: "value",
              unit_field: "unit",
              unit_conversions: {
                m3: 1,
                "m³": 1,
                L: 0.001,
                l: 0.001,
              },
            },
          ],
        },
        aggregations: ["count", "last", "difference"],
        category: "basic",
        cumulative: true,
      },
    ],
    aggregations: [
      {
        data_fields: ["Volume"],
        aggregations: ["count", "last"],
      },
    ],
    compound_aggregations: [],
  },
  gas_meter: {
    data_fields: [
      {
        name: "Volume",
        unit: "m3",
        field: {
          elvaco_mbus: [
            {
              name: "volume,m3,inst-value,0,0,0",
            },
          ],
          email_receiver: [
            {
              name: "value",
              unit_field: "unit",
              unit_conversions: {
                m3: 1,
                "m³": 1,
                L: 0.001,
                l: 0.001,
              },
            },
          ],
        },
        aggregations: ["count", "last", "difference"],
        category: "basic",
        cumulative: true,
      },
    ],
    aggregations: [
      {
        data_fields: ["Volume"],
        aggregations: ["count", "last"],
      },
    ],
    compound_aggregations: [],
  },
  room_sensor: {
    data_fields: [
      {
        name: "Humidity",
        unit: "%RH",
        field: {
          elvaco_mbus: [
            {
              name: "relative-humidity ,%,inst-value,0,0,0",
            },
            {
              name: "relative-humidity,%,inst-value,0,0,0",
            },
          ],
        },
        aggregations: ["count", "min", "max", "mean", "time_weighted_average"],
        category: "technical",
      },
      {
        name: "Temperature",
        unit: "°C",
        field: {
          elvaco_mbus: [
            {
              name: "ext-temp,°C,inst-value,0,0,0",
            },
            {
              name: "external-temperature,˚C,inst-value,0,0,0",
            },
          ],
        },
        aggregations: ["count", "min", "max", "mean", "time_weighted_average"],
        category: "basic",
      },
    ],
    aggregations: [
      {
        data_fields: ["Humidity", "Temperature"],
        aggregations: ["min", "max", "mean", "count", "time_weighted_average"],
      },
    ],
    compound_aggregations: [],
  },
  co2_room_sensor: {
    data_fields: [
      {
        name: "Humidity",
        unit: "%RH",
        field: {
          elvaco_mbus: [
            {
              name: "relative-humidity ,%,inst-value,0,0,0",
            },
          ],
        },
        aggregations: ["count", "min", "max", "mean", "time_weighted_average"],
        category: "technical",
      },
      {
        name: "CO2",
        unit: "ppm",
        field: {
          elvaco_mbus: [
            {
              name: "dimensionless,,inst-value,0,0,0",
            },
          ],
        },
        aggregations: ["count", "min", "max", "mean", "time_weighted_average"],
        category: "technical",
      },
      {
        name: "Temperature",
        unit: "°C",
        field: {
          elvaco_mbus: [
            {
              name: "ext-temp,°C,inst-value,0,0,0",
            },
          ],
        },
        aggregations: ["count", "min", "max", "mean", "time_weighted_average"],
        category: "basic",
      },
    ],
    aggregations: [
      {
        data_fields: ["Humidity", "Temperature", "CO2"],
        aggregations: ["min", "max", "mean", "count", "time_weighted_average"],
      },
    ],
    compound_aggregations: [],
  },
  input_output_module: {
    data_fields: [],
    aggregations: [],
    compound_aggregations: [],
  },
  wireless_receiver: {
    data_fields: [],
    aggregations: [],
    compound_aggregations: [],
  },
  gateway: {
    data_fields: [
      {
        name: "RSSI",
        unit: "dB",
        field: ["rssi", "rf-level,dBm,inst-value,0,0,0"],
        aggregations: ["min", "max", "mean", "time_weighted_average", "count"],
        category: "technical",
      },
      {
        name: "Data Received",
        field: "data_received_bytes",
        unit: "bytes",
        aggregations: ["min", "max", "mean", "time_weighted_average", "count"],
        category: "technical",
      },
      {
        name: "Devices (Received)",
        unit: "",
        field: "devices_received",
        aggregations: ["min", "max", "mean", "time_weighted_average", "count"],
        category: "technical",
      },
      {
        name: "Devices (Total)",
        unit: "",
        field: "devices_total",
        aggregations: ["min", "max", "mean", "time_weighted_average", "count"],
        category: "technical",
      },
      {
        name: "Data Points Received (Total)",
        unit: "",
        field: "rows_received_total",
        aggregations: ["min", "max", "mean", "time_weighted_average", "count"],
        category: "technical",
      },
      {
        name: "Data Points Received (Good)",
        unit: "",
        field: "rows_received_good",
        aggregations: ["min", "max", "mean", "time_weighted_average", "count"],
        category: "technical",
      },
      {
        name: "Data Points Received (Parse Error)",
        unit: "",
        field: "rows_received_parse_error",
        aggregations: ["min", "max", "mean", "time_weighted_average", "count"],
        category: "technical",
      },
      {
        name: "Data Points Received (Value Error)",
        unit: "",
        field: "rows_received_value_error",
        aggregations: ["min", "max", "mean", "time_weighted_average", "count"],
        category: "technical",
      },
      {
        name: "Data Points Received (Duplicate)",
        unit: "",
        field: "rows_received_duplicate",
        aggregations: ["min", "max", "mean", "time_weighted_average", "count"],
        category: "technical",
      },
    ],
    aggregations: [
      {
        data_fields: [
          "RSSI",
          "Data Received",
          "Devices (Received)",
          "Devices (Total)",
          "Data Points Received (Total)",
          "Data Points Received (Good)",
          "Data Points Received (Parse Error)",
          "Data Points Received (Value Error)",
          "Data Points Received (Duplicate)",
        ],
        aggregations: ["min", "max", "mean", "time_weighted_average", "count"],
      },
    ],
    compound_aggregations: [],
  },
};

export default TIME_SERIES_TEMPLATES;
